module.exports = "/static/assets/430fec58404987993c5037925ee62c98.png";